'use client'

import { ReactNode } from 'react'
import { Cell, Text } from '@vinted/web-ui'

import { List } from '@marketplace-web/common-components/list-ui'
import {
  FilterGroupModel,
  FilterCatalogModel,
  FilterCatalogModelWithFilterGroups,
} from '@marketplace-web/catalog/catalog-data'

type Props<T> = {
  catalogs: Array<FilterCatalogModel> | Array<FilterCatalogModelWithFilterGroups<T>>
  onItemClick: (catalog: FilterCatalogModel | FilterCatalogModelWithFilterGroups<T>) => void
  renderSuffix?: (filterGroups: Array<FilterGroupModel<T>>) => ReactNode
}

const FilterCatalogList = <T,>({ catalogs, onItemClick, renderSuffix }: Props<T>) => {
  const handleClick =
    (catalog: FilterCatalogModel | FilterCatalogModelWithFilterGroups<string>) => () => {
      onItemClick(catalog)
    }

  const getCatalogSuffix = (
    catalog: FilterCatalogModel | FilterCatalogModelWithFilterGroups<T>,
  ) => {
    if (!renderSuffix) return null
    if (!('matchingGroups' in catalog)) return null

    return renderSuffix(catalog.matchingGroups)
  }

  const renderCatalog = (
    catalog: FilterCatalogModel | FilterCatalogModelWithFilterGroups<string>,
  ) => {
    const suffix = getCatalogSuffix(catalog)

    return (
      <Cell
        key={catalog.code}
        type="navigating"
        body={<Text as="h2" text={catalog.title} type="title" />}
        suffix={suffix}
        chevron={!suffix}
        onClick={handleClick(catalog)}
      />
    )
  }

  return <List>{catalogs.map(renderCatalog)}</List>
}

export default FilterCatalogList
